import { Link } from "react-router-dom";
import { T } from "@/components/T";
import { Divider } from "@/components/MotifBackground";

export default function NotFound() {
  return (
    <div className="mx-auto flex max-w-xl flex-col items-center px-5 py-32 text-center">
      <p className="font-deva text-6xl text-saffron">ॐ</p>
      <Divider className="my-8" />
      <h1 className="font-serif-latin text-4xl text-ink"><T>Page not found</T></h1>
      <p className="mt-3 text-ink-2"><T>The page you are looking for is not part of Dharmartha.</T></p>
      <Link to="/" className="mt-8 inline-flex items-center gap-2 bg-[var(--saffron)] px-7 py-3 font-medium text-white transition-colors hover:bg-[var(--saffron-dark)]">
        <T>Return home</T>
      </Link>
    </div>
  );
}
